<ng-container *ngIf="isStep; else isNotStep">
  <app-breadcrumbs *ngIf="!!breadcrumbs" [breadcrumbs]="breadcrumbs" class="breadcrumbs isStep"></app-breadcrumbs>
</ng-container>

<ng-template #isNotStep>
  <section id='container' class="container">
    <div id="em-title" name="em-title" class="title-element">
      <app-breadcrumbs *ngIf="!!breadcrumbs" [breadcrumbs]="breadcrumbs" class="breadcrumbs"></app-breadcrumbs>
      <div class="title-text title-text-sm mat-body-1" >
        {{ title }}
      </div>
      <h1 title="{{ moduleName }}" class="title-text-module">
        {{ moduleName }}
      </h1>
    </div>
      <div class="container-logo">
        <app-person [totalScore]="totalScore"></app-person>
        <app-progress-spinner class="spinner-value-text"
          [value]="totalScore"
          [isHeader]="isHeader">
        </app-progress-spinner>
      </div>
  </section>
</ng-template>